import { observer } from 'mobx-react-lite'
import React from 'react'
import { formatNumber } from '../../../../../utils/Helper'
import { useReadOnly } from '../../../../../contexts/ReadOnlyContext'

function formatKpi(value) {
  const num = Number(value)
  if (isNaN(num)) return value
  return formatNumber(num, 2)
}

export default observer(function OverviewKpiWidget({ showUpdateModal, title, kpi, target, icon, hasScenario }) {
  const readOnly = useReadOnly()
  const displayKpi = formatKpi(kpi)
  const displayTarget = formatKpi(target)

  return (
    <div
      className={`bg-white dark:bg-rb-dark-mode rounded-lg p-2 flex flex-col justify-between border-1 border-rb-widget-boarder dark:border-rb-dark-mode-lighter min-h-24 ${readOnly ? '' : 'hover:cursor-pointer hover:shadow-md hover:transform hover:scale-102 transition-all duration-200'}`}
      onClick={readOnly ? undefined : () => showUpdateModal(true)}
    >
      <p className="text-sm font-bold flex items-center text-rb-green dark:text-gray-400">{icon} <span className="ml-2">{title}</span></p>
      <div className="flex justify-between gap-2">
        <div className="w-1/2 dark:text-gray-500rounded-lg bg-rb-soft-green dark:bg-rb-dark-mode-background p-2">
          {hasScenario && <p className='text-xs dark:text-gray-400'>Current</p>}
          {hasScenario && <p className=" font-bold text-xl dark:text-white">{displayKpi}</p>}
        </div>
        <div className="rounded-lg bg-rb-soft-green dark:bg-rb-dark-mode-background p-2 w-1/2">
          <p className='text-xs text-right dark:text-gray-400'>Target</p>
          <p className="font-bold text-xl text-right dark:text-white">{displayTarget}</p>
        </div>
      </div>
    </div>
  )
})
